define(
  [
    "underscore",
    "i18n/i18n",
    "client/appfragment/persisted",
    "client/appfragment/builtin",
    "client/appfragment/composite",
    "client/client-extensions/result-properites-enrichment-handler-set",
    "client/client-extensions/composite-result-properties-enrichment-factory-v1",
  ],
  function(
    _,
    i18n,
    { PersistedAppFragmentStore },
    { BuiltinReadonlyAppFragmentStore },
    { CompositeReadonlyAppFragmentStore },
    ResultPropertiesEnrichmentHandlerSet,
    CompositeResultPropertiesEnrichmentHandlerFactoryV1
  ) {
    function BuiltinClientExtensions(application, clientExtensionsProvider, options) {
      var options = options || {};
      this.options = _.extend({}, options);
      this.application = application;
      this.extensions = null;
      
      // TODO: make overridable
      this.builtinAppFragmentStore = new BuiltinReadonlyAppFragmentStore(options);
      this.initialize();
      this.resultPropertiesEnrichmentHandlerV1 = new ResultPropertiesEnrichmentHandlerSet();
      if (options.persistedResourcesAppFragmentStoreCollection) {
        this.persistedResourcesAppFragmentStore = new PersistedAppFragmentStore({collectionName: options.persistedResourcesAppFragmentStoreCollection});
      }

      if (clientExtensionsProvider && _.isFunction(clientExtensionsProvider.getExtensions)) {
        this.extensions = clientExtensionsProvider.getExtensions(i18n.currentLanguage(), this.application.options);
      }
      
      //
      // Only use builtinAppFragmentStore if we are using theming.
      //
      this.appFragmentStores = this.application.options.useShadowRoot ? [this.builtinAppFragmentStore] : [];
      if (this.extensions && _.isFunction(this.extensions.getReadonlyAppFragmentStoreV1)) {
        this.appFragmentStores.push(this.extensions.getReadonlyAppFragmentStoreV1());
      }
      if (this.persistedResourcesAppFragmentStore) {
        this.appFragmentStores.push(this.persistedResourcesAppFragmentStore);
      }

      this.compositeAppFragmentStore = new CompositeReadonlyAppFragmentStore(this.appFragmentStores);
      
      this.compositeResultPropertiesEnrichmentHandlerFactoryV1 = new CompositeResultPropertiesEnrichmentHandlerFactoryV1(
        this._getFactories.bind(this)
      );
    }

    _.extend(BuiltinClientExtensions.prototype, {
      initialize: function(){
        if (this.builtinAppFragmentStore.options && this.builtinAppFragmentStore.options.experimentalBuiltinModules) {
          this.loadExperimentalBuiltin();      
        }
      },
      loadExperimentalBuiltin: function() {
        var documentFragment = this.builtinAppFragmentStore.options.el;
        this.loadHTMLAsync("../client/resources/appfragments/builtin-experimental.html")
          .then(function(fragmentText) {
            var template = document.createElement("template");
            template.innerHTML = fragmentText;
            var newFragment = template.content;
            while (newFragment.firstChild) {
              documentFragment.appendChild(newFragment.firstChild);
            }
          })
          .catch(function(error) {
            console.error("Failed to load builtin-experimental file", error);
          });
      },

      loadHTMLAsync: function(path) {
        return new Promise(function(resolve, reject) {
          Mindbreeze.require(["text!" + path], function(fragmentText) {
            resolve(fragmentText);
          }, function(error) {
            reject(error);
          });
        });
      },
      getReadonlyAppFragmentStoreV1: function() {
        return this.compositeAppFragmentStore;
      },

      getI18NProviderV1: function() {
        if (this.extensions && _.isFunction(this.extensions.getI18NProviderV1)) {
          return this.extensions.getI18NProviderV1();
        }
        return null;
      },

      getResultPropertiesEnrichmentHandlerFactoryV1: function() {
        return this.compositeResultPropertiesEnrichmentHandlerFactoryV1;
      },

      registerResultPropertiesEnrichmentHandlerFactoryV1: function(factory, priority) {
        if (
          typeof priority === "number" &&
          priority >= 0 &&
          priority < this.resultPropertiesEnrichmentHandlerV1.size()
        ) {
          this.resultPropertiesEnrichmentHandlerV1.addToIndex(factory, priority);
          return;
        }

        this.resultPropertiesEnrichmentHandlerV1.add(factory);
      },

      unregisterResultPropertiesEnrichmentHandlerFactoryV1: function(factory) {
        this.resultPropertiesEnrichmentHandlerV1.remove(factory);
      },

      _getFactories: function() {
        var factories = [];
        this._tryAppendFactory(this.extensions, factories);
        var handlers = this.resultPropertiesEnrichmentHandlerV1.values();
        for (var handlerIndex = 0; handlerIndex < handlers.length; handlerIndex++) {
          this._tryAppendFactory(handlers[handlerIndex], factories);
        }
        return factories;
      },

      _tryAppendFactory: function(extension, factories) {
        if (!extension) {
          return;
        }
        try {
          var factory = extension.getResultPropertiesEnrichmentHandlerFactoryV1();
          if (factory) {
            factories.push(factory);
          }
        } catch (error) {
          if (console && console.warn) {
            console.warn("Failed to get result properties enrichment factory, skipping.", error);
          }
        }
      }
    });

    return BuiltinClientExtensions;
  }
);
